export default {"src":"/_next/static/media/two-giv.31526dd1.svg","height":389,"width":319,"blurWidth":0,"blurHeight":0};